import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

/**
 * AI Curriculum wizard edits that haven't reached the server, buffered so a
 * refresh doesn't lose them (ENG-23196): answers typed before submitting, and
 * answers changed after going back from the review step. Everything the
 * session already holds is refetched on restore.
 */

export const aiCurriculumDraftKey = (orgCode, classroomId) =>
  `${orgCode}:${classroomId}`;

export const useAiCurriculumUIStore = create(
  persist(
    (set, get) => ({
      draftsByClassroom: {},

      getDraft: (orgCode, classroomId) =>
        get().draftsByClassroom[aiCurriculumDraftKey(orgCode, classroomId)],

      saveDraft: (orgCode, classroomId, draft) =>
        set((state) => ({
          draftsByClassroom: {
            ...state.draftsByClassroom,
            [aiCurriculumDraftKey(orgCode, classroomId)]: draft,
          },
        })),

      clearDraft: (orgCode, classroomId) =>
        set((state) => {
          const key = aiCurriculumDraftKey(orgCode, classroomId);
          if (!(key in state.draftsByClassroom)) return state;
          const { [key]: _removed, ...rest } = state.draftsByClassroom;
          return { draftsByClassroom: rest };
        }),

      clearStore: () => set({ draftsByClassroom: {} }),
    }),
    {
      name: "ai-curriculum-ui-store",
      version: 1,
      // sessionStorage: survives refresh, stays per-tab so two open wizards
      // can't overwrite each other's session id.
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ draftsByClassroom: state.draftsByClassroom }),
      migrate: () => ({ draftsByClassroom: {} }),
    }
  )
);
